/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ArchiveCatalogCategoryInput } from '../models/ArchiveCatalogCategoryInput';
import type { ArchiveCatalogItemInput } from '../models/ArchiveCatalogItemInput';
import type { CatalogCategoryCreateDTO } from '../models/CatalogCategoryCreateDTO';
import type { CatalogCategoryOut } from '../models/CatalogCategoryOut';
import type { CatalogItemCreateDTO } from '../models/CatalogItemCreateDTO';
import type { CatalogItemOut } from '../models/CatalogItemOut';
import type { CatalogItemSortBy } from '../models/CatalogItemSortBy';
import type { SortDirection } from '../models/SortDirection';
import type { UpdateCatalogCategoryInput } from '../models/UpdateCatalogCategoryInput';
import type { UpdateCatalogItemInput } from '../models/UpdateCatalogItemInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CatalogService {
  /**
   * Get Catalog Categories
   * @returns CatalogCategoryOut Successful Response
   * @throws ApiError
   */
  public static getCatalogCategories(): CancelablePromise<Array<CatalogCategoryOut>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/catalog/category',
    });
  }

  /**
   * Update Catalog Category
   * @param requestBody
   * @returns CatalogCategoryOut Successful Response
   * @throws ApiError
   */
  public static updateCatalogCategory(requestBody: UpdateCatalogCategoryInput): CancelablePromise<CatalogCategoryOut> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/catalog/category',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Catalog Category
   * @param requestBody
   * @returns CatalogCategoryOut Successful Response
   * @throws ApiError
   */
  public static createCatalogCategory(requestBody: CatalogCategoryCreateDTO): CancelablePromise<CatalogCategoryOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/catalog/category',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Archive Catalog Category
   * @param requestBody
   * @returns CatalogCategoryOut Successful Response
   * @throws ApiError
   */
  public static archiveCatalogCategory(
    requestBody: ArchiveCatalogCategoryInput,
  ): CancelablePromise<CatalogCategoryOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/catalog/category/archive',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Create Catalog Item
   * @param requestBody
   * @returns CatalogItemOut Successful Response
   * @throws ApiError
   */
  public static createCatalogItem(requestBody: CatalogItemCreateDTO): CancelablePromise<CatalogItemOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/catalog/item',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Catalog Item
   * @param requestBody
   * @returns CatalogItemOut Successful Response
   * @throws ApiError
   */
  public static updateCatalogItem(requestBody: UpdateCatalogItemInput): CancelablePromise<CatalogItemOut> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/catalog/item',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Catalog Items
   * @param page Page number
   * @param perPage Items per page
   * @param search Search value
   * @param categoryIds Filter by categories
   * @param tags Filter by tags (any match)
   * @param minPrice Lowest price to include
   * @param maxPrice Highest price to include
   * @param includeArchived Include archived items
   * @param sortBy Sort field
   * @param sortDirection Sort direction
   * @returns CatalogItemOut Successful Response
   * @throws ApiError
   */
  public static getCatalogItems(
    page: number = 1,
    perPage: number = 500,
    search?: string,
    categoryIds?: Array<string> | null,
    tags?: Array<string> | null,
    minPrice?: number | null,
    maxPrice?: number | null,
    includeArchived: boolean = false,
    sortBy?: CatalogItemSortBy,
    sortDirection?: SortDirection,
  ): CancelablePromise<Array<CatalogItemOut>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/catalog/item',
      query: {
        page: page,
        per_page: perPage,
        search: search,
        category_ids: categoryIds,
        tags: tags,
        min_price: minPrice,
        max_price: maxPrice,
        include_archived: includeArchived,
        sort_by: sortBy,
        sort_direction: sortDirection,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Archive Catalog Item
   * @param requestBody
   * @returns CatalogItemOut Successful Response
   * @throws ApiError
   */
  public static archiveCatalogItem(requestBody: ArchiveCatalogItemInput): CancelablePromise<CatalogItemOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/catalog/item/archive',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
